import { APP_ROUTES } from "configs";
import Logo from "images/logo-login.svg";
import { memo } from "react";
import { Link } from "react-router";
import style from "./index.module.scss";

export const Header = memo(() => {
  return (
    <header className={style.root}>
      <Link to={APP_ROUTES.HOME().config} className={style.logo}>
        <img src={Logo} alt={"logo"} />
      </Link>
    </header>
  );
});
